import type { SessionHandoff } from '../../api/memory-v2'

function Section({ title, items }: { title: string; items: string[] }) {
  if (items.length === 0) return null
  return (
    <div>
      <h4 className="text-xs font-semibold uppercase tracking-wide text-harbor-text-secondary">
        {title}
      </h4>
      <ul className="mt-1 list-inside list-disc text-sm text-harbor-text">
        {items.map((item, index) => (
          <li key={`${title}-${index}`}>{item}</li>
        ))}
      </ul>
    </div>
  )
}

export function HandoffDetails({ handoff }: { handoff: SessionHandoff }) {
  const { content, agentAssertions, observedEvidence } = handoff
  return (
    <div className="space-y-3 rounded-lg border border-harbor-border bg-harbor-surface p-4">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-harbor-text">Handoff</span>
        <span className="text-xs text-harbor-text-muted">version {handoff.versionNumber}</span>
      </div>
      <div className="rounded-lg bg-harbor-surface-raised p-3">
        <h4 className="text-xs font-semibold uppercase tracking-wide text-harbor-text-secondary">
          Agent assertions
        </h4>
        <p className="mt-1 text-sm text-harbor-text">{agentAssertions.outcome}</p>
        <div className="mt-2 space-y-2">
          <Section title="Decisions" items={agentAssertions.decisions} />
          <Section title="Tests" items={agentAssertions.tests} />
          <Section title="Next actions" items={agentAssertions.nextActions} />
        </div>
      </div>
      <div className="rounded-lg bg-harbor-surface-raised p-3">
        <h4 className="text-xs font-semibold uppercase tracking-wide text-harbor-text-secondary">
          Observed evidence
        </h4>
        <p className="mt-1 text-sm text-harbor-text">{content.outcome}</p>
        <div className="mt-2 space-y-2">
          <Section title="Changed resources" items={content.changedResources} />
          <Section title="Issues" items={content.issues} />
        </div>
        <p className="mt-2 text-xs text-harbor-text-muted">
          Verified references: {handoff.verifiedResourceIds.length} · evidence keys:{' '}
          {Object.keys(observedEvidence).join(', ') || 'none'}
        </p>
      </div>
    </div>
  )
}
